var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDarkOverlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.316244 0.294376C0.737904 -0.0981254 1.42155 -0.0981254 1.84321 0.294376L7.55808 5.61407L13.273 0.294376C13.6946 -0.0981254 14.3783 -0.0981254 14.7999 0.294376C15.2216 0.686878 15.2216 1.32325 14.7999 1.71575L9.08504 7.03544L14.7999 12.3551C15.2216 12.7476 15.2216 13.384 14.7999 13.7765C14.3783 14.169 13.6946 14.169 13.273 13.7765L7.55808 8.45682L1.84321 13.7765C1.42155 14.169 0.737904 14.169 0.316244 13.7765C-0.105415 13.384 -0.105415 12.7476 0.316244 12.3551L6.03112 7.03544L0.316244 1.71575C-0.105415 1.32325 -0.105415 0.686878 0.316244 0.294376Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDarkOverlayIcon);
export default __webpack_public_path__ + "static/media/close-dark-overlay-icon.9d1ccc190797ad8a47382a00be571869.svg";
export { ForwardRef as ReactComponent };